export function CurrencyEmpty({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="200"
        height="118"
        viewBox="0 0 200 118"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M54.0018 19.8208C55.9681 28.0211 60.7637 34.459 68.3887 39.1344"
          stroke="var(--clr-title)"
          strokeOpacity="0.2"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeDasharray="1 7"
        />
        <path
          opacity="0.9"
          d="M49.9802 15.2568C46.7503 8.80945 49.4747 3.10176 55.5522 2.84902C56.7973 9.0498 54.1962 13.7651 49.9802 15.2568Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.65"
          d="M49.9802 15.2567C43.7795 16.5018 39.3107 11.916 40.0503 5.96172C46.0045 6.70135 49.6042 10.1716 49.9802 15.2567Z"
          fill="var(--clr-general-primary)"
        />
        <path
          d="M100 115C125.405 115 146 94.4051 146 69C146 43.5949 125.405 23 100 23C74.5949 23 54 43.5949 54 69C54 94.4051 74.5949 115 100 115Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          opacity="0.3"
          d="M100 107C120.987 107 138 89.9868 138 69C138 48.0132 120.987 31 100 31C79.0132 31 62 48.0132 62 69C62 89.9868 79.0132 107 100 107Z"
          stroke="var(--clr-general-primary)"
        />
        <path
          d="M100.382 48.312C99.1518 48.312 98.0425 48.078 97.0545 47.61C96.0838 47.142 95.2692 46.5267 94.6105 45.764C93.9692 45.0013 93.5098 44.178 93.2325 43.294L94.7405 42.748C95.2258 44.0653 95.9452 45.0707 96.8985 45.764C97.8692 46.4573 99.0218 46.804 100.356 46.804C101.24 46.804 102.012 46.6567 102.67 46.362C103.346 46.0673 103.875 45.6513 104.256 45.114C104.638 44.5767 104.828 43.944 104.828 43.216C104.828 42.2107 104.542 41.4307 103.97 40.876C103.416 40.3213 102.688 39.9227 101.786 39.68L98.2505 38.64C96.8118 38.224 95.7458 37.5567 95.0525 36.638C94.3765 35.702 94.0385 34.6447 94.0385 33.466C94.0385 32.4433 94.2812 31.5507 94.7665 30.788C95.2692 30.008 95.9452 29.4013 96.7945 28.968C97.6438 28.5347 98.6058 28.318 99.6805 28.318C100.807 28.318 101.812 28.5347 102.696 28.968C103.598 29.384 104.352 29.9387 104.958 30.632C105.582 31.308 106.024 32.062 106.284 32.894L104.802 33.44C104.369 32.244 103.702 31.3427 102.8 30.736C101.899 30.112 100.868 29.8 99.7065 29.8C98.9438 29.8 98.2592 29.9473 97.6525 30.242C97.0458 30.5367 96.5692 30.9527 96.2225 31.49C95.8758 32.0273 95.7025 32.66 95.7025 33.388C95.7025 34.272 95.9538 35.026 96.4565 35.65C96.9592 36.274 97.7998 36.768 98.9785 37.132L102.15 38.068C103.537 38.484 104.603 39.1253 105.348 39.992C106.111 40.8413 106.492 41.89 106.492 43.138C106.492 44.1607 106.232 45.062 105.712 45.842C105.192 46.6047 104.464 47.2113 103.528 47.662C102.61 48.0953 101.561 48.312 100.382 48.312ZM99.4725 50.6V26.03H100.98V50.6H99.4725Z"
          fill="var(--clr-general-primary)"
        />
        <path
          d="M84 73C88 77.6667 92 77.6667 96 73"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M104 73C108 77.6667 112 77.6667 116 73"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M92 87C97.3333 91 102.667 91 108 87"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          opacity="0.18"
          d="M78.5 85.5C80.1569 85.5 81.5 84.1569 81.5 82.5C81.5 80.8431 80.1569 79.5 78.5 79.5C76.8431 79.5 75.5 80.8431 75.5 82.5C75.5 84.1569 76.8431 85.5 78.5 85.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.18"
          d="M118.5 85.5C120.157 85.5 121.5 84.1569 121.5 82.5C121.5 80.8431 120.157 79.5 118.5 79.5C116.843 79.5 115.5 80.8431 115.5 82.5C115.5 84.1569 116.843 85.5 118.5 85.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.45"
          d="M167 31L169 36L174 38L169 40L167 45L165 40L160 38L165 36L167 31Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.4"
          d="M36.6 100.2C38.0359 100.2 39.2 99.0359 39.2 97.6C39.2 96.1641 38.0359 95 36.6 95C35.1641 95 34 96.1641 34 97.6C34 99.0359 35.1641 100.2 36.6 100.2Z"
          fill="var(--clr-general-primary)"
        />
      </svg>
    </span>
  );
}
